import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/lib/config/constants';

interface SidebarState {
  collapsed: boolean;
  toggle(): void;
  setCollapsed(collapsed: boolean): void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    {
      name: STORAGE_KEYS.sidebar,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
